import type { FaireProductEntity } from "../../entity_types/product";

export const p_2da2vev4bx: FaireProductEntity = {
  token: "p_2da2vev4bx",
  type: "product",
  name: "Pencil Heart and Shavings Earrings | Teacher Jewelry Gifts",
  brandToken: "b_cllfpw8grf",
  brandName: "Tiny Gift Society",
  imageUrl:
    "https://cdn.faire.com/fastly/34034649672231af014ae1cb5e6474d062ee4e41a3759179299d34579756ba9f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b5146781156b83796cb86ae65e7ce78c0b9ff9ac8503a7da63ee119d1f48daf.png",
  ],
  priceDollars: 4.16,
  description:
    "Looking for the perfect little teacher thank you?  These heart shaped pencil earrings, paired with pencil shavings make the perfect gifts.  Custom designed by Teacher Besties Design Co.  Limited Quantities available.\n\nGreat for:\n- Thank You Gifts\n- Customer Appreciation Gifts\n- Table Fillers\n- Sub Boxes (Subscription Boxes)\n- Stud Earrings\n- Women Teens Girls",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:26.709Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
